import { getQuote, getQuoteKey } from '#pplx/frontend/apps/ask/automations/getQuote.js';
import { getNewswireDocumentByDocumentId, getNewswireDocumentByDocumentIdKey, } from '#pplx/frontend/apps/ask/finance/queries/getNewswireDocumentByDocumentId.js';
import { getPoliticians, getPoliticiansKey, } from '#pplx/frontend/apps/ask/finance/queries/getPoliticians.js';
import { getPredictionMarketEvent, getPredictionMarketEventKey, } from '#pplx/frontend/apps/ask/finance/queries/getPredictionMarkets.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export const useFinanceRouteData = (routeParams) => {
    const tickerSymbol = routeParams.type === 'asset' ? routeParams.uuid : undefined;
    const { data: tickerSearchData } = useQuery({
        enabled: !!tickerSymbol,
        queryKey: getQuoteKey(tickerSymbol ?? ''),
        queryFn: () => getQuote(tickerSymbol),
    });
    const uuid = routeParams.type !== null ? routeParams.uuid : undefined;
    const predictionEventId = routeParams.type === 'index' && routeParams.section === 'predictions' ? uuid : undefined;
    const newsDocumentId = routeParams.type === 'index' && routeParams.section === 'news' ? uuid : undefined;
    const politicianId = routeParams.type === 'index' && routeParams.section === 'politicians' ? uuid : undefined;
    const { data: predictionEventData } = useQuery({
        queryKey: getPredictionMarketEventKey({
            eventId: predictionEventId ?? '',
            withCommentary: false,
            historyPeriod: 'max',
        }),
        queryFn: () => getPredictionMarketEvent({
            eventId: predictionEventId,
            historyPeriod: 'max',
        }),
        enabled: !!predictionEventId,
    });
    const { data: newsDocumentData } = useQuery({
        queryKey: getNewswireDocumentByDocumentIdKey(newsDocumentId ?? ''),
        queryFn: () => getNewswireDocumentByDocumentId({
            documentId: newsDocumentId,
        }),
        enabled: !!newsDocumentId,
    });
    const { data: allPoliticians } = useQuery({
        queryKey: getPoliticiansKey(),
        queryFn: () => getPoliticians(),
        enabled: !!politicianId,
    });
    const politicianData = allPoliticians?.find((p) => p.politician_id === politicianId) ?? null;
    return {
        tickerSearchData,
        predictionEventData,
        newsDocumentData,
        politicianData,
    };
};
//# sourceMappingURL=routeData.js.map